<template>
  <component :is="componentTag" />
</template>
<script>
import webWorkNews from './web';
import mobileWorkNews from './mobile';
export default {
  components: {
    webWorkNews,
    mobileWorkNews
  },
  data() {
    return {
       isMobile: false,
       componentTag: ''
    };
  },
  created() {
     this.listenObserverWidth(750);
  },
  methods: {
    // 监听可视窗口宽度
    listenObserverWidth(mobileWidth) {
       const resizeObserver = new ResizeObserver(entries => {
          for(let entry of entries) {
             if(entry.contentRect.width <= mobileWidth) {
                this.componentTag = 'mobileWorkNews';
             } else {
                this.componentTag = 'webWorkNews';
             }
          }
       });
       resizeObserver.observe(document.body);
    }
  },
};
</script>